module.exports = __webpack_public_path__ + "static/media/act-0.a92f31a5.mp3";